/* eslint-disable react/jsx-one-expression-per-line */
import * as Sentry from '@sentry/nextjs';
import { useRouter } from 'next/router';
import React, { FC, memo } from 'react';

import { LocationFilter } from '@core/offices/types';

import DropDown from './filter-dropdown';
import RegularInput from './filter-input';
import DateInput from './filter-input-date';
import EmailInput from './filter-input-email';
import NumberInput from './filter-input-number';
import OptionsInput from './filter-input-options';
import RangeInput from './filter-input-range';

const SupportedFilterInputs = {
  email: EmailInput,
  checkbox: OptionsInput,
  color: RegularInput,
  file: RegularInput,
  image: RegularInput,
  number: NumberInput,
  password: RegularInput,
  radio: OptionsInput,
  range: RangeInput,
  search: RegularInput,
  tel: RegularInput,
  text: RegularInput,
  date: DateInput,
  datetime: DateInput,
  time: DateInput,
  select: DropDown,
};

export interface FilterTogglePropsInterface {
  filter: LocationFilter;
  value: any;
  handleChange: (filterData: LocationFilter, value: any) => void;
}
const PropertyDynamicFilter: FC<FilterTogglePropsInterface> = ({ filter, handleChange, value }) => {
  const router = useRouter();
  if (typeof SupportedFilterInputs[filter.componentType] !== 'undefined') {
    return React.createElement(SupportedFilterInputs[filter.componentType], {
      key: filter.id,
      filter,
      value,
      handleChange: (v: any) => handleChange(filter, v),
    });
  }
  Sentry.setTag('client', router?.query?.clientName as string);
  Sentry.captureException(`The component ${filter.label} with type ${filter.componentType} has not been created yet.`);
  return null;
};
export default memo(PropertyDynamicFilter);
